export default {
  data() {
    return {
      noScrollClass: `noScroll`,
      scrolledClass: `scrolled`,
      offSet: 100,
      itemRefs: [],
    }
  },
  mounted() {
    window.addEventListener(`scroll`, () => {
      this.itemRefs.forEach(item => {
        this.setScrollEvent(item)
      })
    })
  },
  methods: {
    setScrollItem(elem) {
      if (elem) {
        this.itemRefs.push(elem)
      }
    },
    setScrollEvent(elem) {
      let rect = elem.getBoundingClientRect()
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop
      let elemPosition = rect.top + scrollTop
      let windowHeight = window.innerHeight

      if (scrollTop > elemPosition - windowHeight + this.offSet) {
        elem.classList.remove(this.noScrollClass)
        elem.classList.add(this.scrolledClass)
      }
    }
  }
}